import isString from '#shared/util/isString.js';

import { getRequestQuery, getRequestQueryAll, getRequestHeader } from '#backend/util/request.js';

/**
 * Theme schema
 * @param {object} data
 * @param {object} data.request (SERVER ONLY)
 * @param {object} data.response (SERVER ONLY)
 * @returns {object}
 */
export const themeSchema = ({ request, response }) => {
	const trackingDisabled = getRequestQuery(request, 'trackingDisabled') === '1';
	const consentGroups = isString(getRequestQuery(request, 'trackingDisabled'), 2) ? getRequestQuery(request, 'trackingDisabled') : '';
	const useHotjar = getRequestQuery(request, 'useHotjar') === '1' || getRequestQueryAll(request, 'customID').includes('HOTJAR');
	const [, consentId] = getRequestHeader(request, 'cookie', '').match(/consentId=([^&]+)/) ?? ['', '-'];
	return {
		tracking: Object.assign({
			disabled: trackingDisabled,
			consentGroups,
			consentId,
			hotjar: useHotjar,
			type: 'checkout', // Should be hardcoded value
			sdlVersion: '2021-05-05/v1' // Should be hardcoded value
		}, response.locals.theme.config.tracking),
		provider: response.locals.regionConfig.provider,
		variables: response.locals.regionConfig.variables,
		name: response.locals.themeName,
		brand: response.locals.brandName
	};
};
